const IMAGE_EXTENSIONS = ['.jpg', '.jpeg', '.png', '.gif', '.heic', '.svg']
const FILE_EXTENSIONS = [
  '.pdf',
  '.txt',
  '.doc',
  '.docx',
  '.xsl',
  '.xslx',
  '.ppt',
  '.pptx'
]

export { IMAGE_EXTENSIONS, FILE_EXTENSIONS }
